<script>
    import BackArrow from "../../../Components/Common/BackArrow.svelte";
    import ProviderDetailsFormPhase_1 from "./providerDetailsForm_Phase_1.svelte";
    import ProviderDetailsFormPhase_2 from "./providerDetailsForm_Phase_2.svelte";

    export let updatePhase = () => {};
    export let personalDetails = {};

    let providerDetailsFormPhase = 1;
    // let providerDetailsFormPhase = 2;

    const updateProviderDetailsFormPhase = (phase) => {
        if (phase <= 2) providerDetailsFormPhase = phase;
        else updatePhase(5);
    };
</script>

<div class="flex w-full gap-x-4 items-center justify-start">
    <BackArrow
        backFunc={() => {
            providerDetailsFormPhase == 1
                ? updatePhase(3)
                : updateProviderDetailsFormPhase(providerDetailsFormPhase - 1);
        }}
    />
    <p class="text-[32px] font-bold text-primary">Complete Your Profile</p>
</div>

{#if providerDetailsFormPhase == 1}
    <ProviderDetailsFormPhase_1 {updateProviderDetailsFormPhase} />
{:else if providerDetailsFormPhase == 2}
    <ProviderDetailsFormPhase_2
        {updateProviderDetailsFormPhase}
        bind:personalDetails
    />
{/if}
